var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58319 5.49872H10.788L10.7882 5.49864C11.0926 5.5008 11.3826 5.62875 11.5895 5.8521C11.7963 6.07545 11.9016 6.37439 11.8804 6.67805V7.27209C11.879 7.67023 11.8106 8.06533 11.6781 8.44087V8.44097L10.4007 12.0881C10.2801 12.4659 10.0425 12.7955 9.72207 13.0294C9.40176 13.2632 9.0153 13.3892 8.61867 13.3889H3.75594C3.54245 13.3889 3.33773 13.3041 3.18689 13.1532C3.03596 13.0022 2.95118 12.7975 2.95118 12.5841V5.71376C2.9507 5.57261 2.98739 5.43385 3.05763 5.31134L5.71029 0.919191C5.79927 0.762073 5.95362 0.652674 6.13145 0.620834C6.30917 0.588993 6.49186 0.638036 6.62986 0.754564C6.76778 0.871089 6.84667 1.04302 6.84505 1.22361L6.58319 5.49872ZM2.23129 5.86328H0.700479L0.700481 5.86335C0.514683 5.86335 0.336559 5.93711 0.205205 6.06855C0.0738522 6.1999 0 6.37802 0 6.56383V12.3249C0 12.5107 0.0738522 12.6888 0.205205 12.8202C0.336549 12.9515 0.514666 13.0254 0.700481 13.0254H2.2312L2.23129 5.86328Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/LikeIcon.c9cc379405a321e19336612fb4b87086.svg";
export { ForwardRef as ReactComponent };